export default {
  getTaxes: state => state.taxes,
  getTax: state => state.tax
}